<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="false"
    :width="width"
    custom-class="modal-container"
  >
    <div slot="title" class="title">
      <span class="info">
        {{ title }}
      </span>
      <img
        alt="icon"
        class="icon"
        src="@/assets/images/login-dialog/img_64028_0_0.png"
        @click="visible = false"
      />
    </div>
    <div class="pay-select">
      <div
        v-for="item in goodsList"
        :key="item.id"
        class="pay-select-item"
        :class="{
          active: activeGoods.id === item.id,
          disabled: item.status === 0
        }"
        @click="changeActive(item)"
      >
        <div class="pay-title">{{ item.title }}</div>
        <div class="price">{{ parseFloat(item.price) }}</div>
        <div class="split-line"></div>
        <div
          v-for="(rightItem, index) in item.rights"
          :key="rightItem"
          class="desc"
        >
          {{ index + 1 }}、{{ rightItem }}
        </div>
      </div>
    </div>
    <div v-if="qrcode && orderNo" class="pay-info">
      <div class="pay-info-inner">
        <div class="qr-code">
          <img :src="qrcode" alt="" />
        </div>
        <div class="right-content">
          <div class="pay-price">
            应付金额：
            <div class="price-content">{{ activeGoods.price }}</div>
          </div>
          <div class="order-no">订单编号：{{ orderNo || "生成中" }}</div>
          <div class="pay-goods-name">
            购买物品：
            <div class="right">
              {{ activeGoods.title }}
            </div>
          </div>
          <div class="tips">使用微信扫码进行支付</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { Dialog } from "element-ui";
import apis from "@/apis/index";

export default {
  name: "PayDialog",
  components: {
    "el-dialog": Dialog
  },
  props: {
    bookId: {
      type: Number,
      default: NaN
    },
    bookPrice: {
      type: String,
      default: "0"
    },
    type: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      visible: false,
      activeGoods: {},
      currApi: apis.recharge,
      orderNo: "",
      qrcode: ""
    };
  },
  computed: {
    ...mapState(["userInfo", "vipIndex"]),
    title() {
      return this.bookId ? "观看族谱" : "购买会员";
    },
    width() {
      return this.bookId ? "790px" : "620px";
    },
    vipGoods() {
      return this.vipIndex.map(item => ({
        type: "vip",
        id: item.id,
        title: item.levelname,
        price: item.award,
        status: item.status,
        rights: [
          "有效期一年",
          `可查看收费谱书${item.viewcount}本`,
          `上传谱书${item.uploadcount}本`,
          `上传谱书分润${parseFloat(item.uploadaward)}%`,
          `直推会员收益${parseFloat(item.recommendone)}%`,
          !!parseFloat(item.recommendoneSec) &&
            `直推会员续费收益${parseFloat(item.recommendoneSec)}%`,
          !!parseFloat(item.recommendtwo) &&
            `间推会员收益${parseFloat(item.recommendtwo)}%`,
          !!parseFloat(item.recommendtwoSec) &&
            `间推会员续费收益${parseFloat(item.recommendtwoSec)}`
        ].filter(Boolean)
      }));
    },
    currGoods() {
      return {
        type: "goods",
        id: `book_${this.bookId}`,
        title: "单独购买",
        price: this.bookPrice,
        status: 1,
        rights: ["有效期一年"]
      };
    },
    goodsList() {
      return this.bookId ? [this.currGoods, ...this.vipGoods] : this.vipGoods;
    }
  },
  mounted() {
    // this.fetchVipIndex();
    this.activeGoods = {};
  },
  beforeDestroy() {
    this.checkTimer && clearTimeout(this.checkTimer);
  },
  methods: {
    // ...mapActions(["fetchVipIndex"]),
    show() {
      if (!this.userInfo.isLogin) {
        this.bus.emit("login");
        return;
      }
      this.activeGoods = {};
      this.visible = true;
    },

    hide() {
      this.visible = false;
      this.orderNo = "";
      this.qrcode = "";
    },

    changeActive(item) {
      if (item.status === 0) return;
      this.activeGoods = item;
      if (item.type === "vip") {
        this.currApi = apis.recharge;
      } else {
        this.currApi = apis.rechargeBook;
      }
      this.qrcode = "";
      this.orderNo = "";
      this.confirmPay();
    },

    async confirmPay() {
      this.$toast.loading("生成订单中");
      const goodsId =
        this.activeGoods.type === "goods"
          ? this.activeGoods.id.split("_")[1]
          : this.activeGoods.id;
      const {
        data: { user_ewm, out_trade_no }
      } = await this.currApi({
        goods_id: goodsId,
        trade_type: "NATIVE",
        type: this.type
      });
      // console.log(data);
      this.qrcode = user_ewm;
      this.orderNo = out_trade_no;
      this.checkPayStatus();
      this.$toast.clear();
    },

    checkPayStatus() {
      this.checkTimer && clearTimeout(this.checkTimer);
      this.checkTimer = setTimeout(() => {
        if (!this.orderNo) return;

        apis
          .orderDetail({ order_sn: this.orderNo })
          .then(({ data: { data_info } }) => {
            console.log(data_info);
            if (data_info.status === 0) {
              this.checkPayStatus();
            } else {
              this.$emit("success");
              this.visible = false;
              this.$toast("支付成功");
            }
          });
      }, 2000);
    }
  },
  watch: {
    bookId: {
      handler() {
        this.orderNo = "";
        this.qrcode = "";
      }
    },
    visible(val) {
      if (!val) {
        this.orderNo = "";
        this.qrcode = "";
      }
    }
  }
};
</script>

<style lang="scss">
.form-input {
  .el-input__inner {
    color: #CA0A15;
    font-size: 14px;
    border: 1px solid #f0f0f0;
  }
}
</style>

<style lang="scss">
.modal-container {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.title {
  align-items: center;
  background-color: #fbe1c3;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  height: 50px;
  justify-content: space-between;
  overflow: hidden;
  padding-left: 21px;
  padding-right: 20px;
  position: relative;
  width: 100%;

  .info {
    color: #CA0A15;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 16px;
    text-decoration: none;
    font-weight: bold;
  }
  .icon {
    height: 10px;
    width: 10px;
    cursor: pointer;
  }
}

.pay-select {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 20px 0;

  &-item {
    width: 180px;
    height: 300px;
    border-radius: 4px;
    background: rgba(139, 66, 51, 0.2);
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    border: 1px solid transparent;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.active {
      border: 1px solid #CA0A15;
    }

    &.disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }

    .pay-title {
      color: #CA0A15;
      font-size: 16px;
      text-align: center;
      font-weight: bold;
      margin-top: 24px;
      line-height: 1;
    }

    .price {
      color: #CA0A15;
      font-size: 36px;
      text-align: center;
      font-weight: bold;
      margin-top: 19px;
      line-height: 1;

      &::before {
        content: "¥";
        font-size: 24px;
        color: #CA0A15;
      }
    }

    .split-line {
      width: 140px;
      height: 1px;
      background: #CA0A15;
      // border: 1px solid #CA0A15;
      opacity: 0.3;
      margin: 0 auto;
      margin-top: 29px;
      margin-bottom: 20px;
    }

    .desc {
      font-size: 10px;
      color: #CA0A15;
      margin-left: 20px;
      line-height: 18px;
      max-width: 140px;
    }
  }
}

.pay-info {
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  padding-top: 0;

  .pay-info-inner {
    width: 100%;
    height: 180px;
    background-color: #f7f7f7;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;

    .qr-code {
      height: 140px;
      width: 140px;
      border-radius: 4px;
      background: #CA0A15;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .right-content {
      margin-left: 20px;
      .pay-price {
        font-size: 18px;
        color: #666;
        display: flex;
        align-items: flex-end;
        .price-content {
          font-size: 30px;
          line-height: 1;

          &::before {
            content: "¥";
            font-size: 14px;
          }
        }
      }
      .order-no {
        color: #666666;
        font-size: 14px;
        margin-top: 18px;
      }
      .pay-goods-name {
        color: #666666;
        font-size: 14px;
        display: flex;
        margin-top: 13px;

        .right {
          color: #ff5500;
        }
      }
      .tips {
        margin-top: 13px;
        font-size: 12px;
        color: #b5b5b5;
      }
    }
  }
}
</style>
